import React from 'react';
import { Tooltip } from '../base';
import * as S from './avatar-stack.styles';

interface IAvatarStackProps {
    names?: string[];
}

const getInitials = (name: string): string => {
    if (!name) return '';
    
    const parts = name.trim().split(' ');
    if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
    }
    
    const firstInitial = parts[0].charAt(0).toUpperCase();
    const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
};

export const AvatarStack: React.FC<IAvatarStackProps> = ({ names }) => {
    if (!names || names.length === 0) {
        return <S.EmptyState>—</S.EmptyState>;
    }

    const MAX_VISIBLE = 5;
    const visibleNames = names.slice(0, MAX_VISIBLE);
    const remainingCount = names.length - MAX_VISIBLE;
    const hasMore = remainingCount > 0;

    const totalAvatars = hasMore ? MAX_VISIBLE + 1 : visibleNames.length;
    const containerWidth = totalAvatars * 17 + 15;
    return (
        <S.AvatarStackContainer style={{ width: `${containerWidth}px` }}>
            {visibleNames.map((name, index) => {
                const initials = getInitials(name);
                return (
                    <S.AvatarWrapper key={`${name}-${index}`} index={index}>
                        <Tooltip direction="top" title={<span>{name}</span>}>
                            <S.Avatar>
                                {initials}
                            </S.Avatar>
                        </Tooltip>
                    </S.AvatarWrapper>
                );
            })}
            {hasMore && (
                <S.AvatarWrapper index={MAX_VISIBLE}>
                    <Tooltip direction="top" title={<span>{names.slice(MAX_VISIBLE).join(', ')}</span>}>
                        <S.Avatar>
                            +{remainingCount}
                        </S.Avatar>
                    </Tooltip>
                </S.AvatarWrapper>
            )}
        </S.AvatarStackContainer>
    );
};

